import * as I18n from 'circe/I18n';

import { NAME as APP_NAME } from 'constants';

export const NAME = `${APP_NAME}/SHIPMENTS`;

export const REDUCER_NAME = 'shipments';

export const LISTING_ENDPOINT = `${SHIPPING_EDGE}/api/masheed/sales-orders`;

export const WAYBILLS_LISTING = `${SHIPPING_EDGE}/api/shipments?domain=${SYSTEM_DOMAIN}}`;

export const ASSIGN_ORDERS_FORM_NAME = 'ASSIGN_ORDERS';

export const REASSIGN_ORDERS_FORM_NAME = 'REASSIGN_ORDERS';

export const ASSIGN_ORDERS_MIME_TYPES = [
  '.csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
].join(', ');

export const SHIPMENT_STATUS = {
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  ENROUTE: 'ENROUTE',
  SCHEDULED: 'SCHEDULED',
  REJECTED: 'REJECTED',
  DELAYED: 'DELAYED',
  EXCEPTION: 'EXCEPTION',
  LOADING: 'LOADING',
  UN_LOADING: 'UN_LOADING',
  DELIVERED: 'DELIVERED',
  DISPATCHED: 'DISPATCHED',
  PROPOSED: 'PROPOSED',
  ORDERED: 'ORDERED',
  CONFIRMED: 'CONFIRMED',
  IN_ROUTE: 'IN_ROUTE',
  UNLOADING: 'UNLOADING',
  UNASSIGNED: 'UNASSIGNED',
  SELECTED: 'SELECTED',
};

export const ROUTES = {
  ROOT: '/shipments',
  ROOT2: '/waybills',
};
export const SALES_CATEGORIES = [
  {
    value: 'BLC-Bulk',
    label: 'BLC-Bulk',
    division: null,
  },
  {
    value: 'Flyash-Bags',
    label: 'Flyash-Bags',
    division: 'Cement Replacement',
  },
  {
    value: 'Flyash-Bulk',
    label: 'Flyash-Bulk',
    division: 'Cement Replacement',
  },
  {
    value: 'Microsilica-Bags',
    label: 'Microsilica-Bags',
    division: 'Cement Replacement',
  },
  {
    value: 'Microsilica-Bulk',
    label: 'Microsilica-Bulk',
    division: 'Cement Replacement',
  },
  {
    value: 'GGBFS-Bags',
    label: 'GGBFS-Bags',
    division: 'Cement Replacement',
  },
  {
    value: 'GGBFS-Bulk',
    label: 'GGBFS-Bulk',
    division: 'Cement Replacement',
  },
  {
    value: 'PRECASTO',
    label: 'Precasto',
    division: 'Gery Cement',
  },
  {
    value: 'JORDAN',
    label: 'Jordan',
    division: 'Gery Cement',
  },

  {
    value: 'Type-II Bulk',
    label: 'Type-II Bulk',
    division: null,
  },
  {
    value: 'Type-III Bulk',
    label: 'Type-III Bulk',
    division: null,
  },
  {
    value: 'Cement Ash',
    label: 'Cement Ash',
    division: null,
  },
  {
    value: 'White Cem-I Bulk',
    label: 'White Cem-I Bulk',
    division: 'White Cement',
  },
  {
    value: 'White Cem-II Bulk',
    label: 'White Cem-II Bulk',
    division: 'White Cement',
  },
  {
    value: 'Clinker',
    label: 'Clinker',
    division: 'Cement',
  },
  {
    value: 'FNG-Bulk',
    label: 'FNG-Bulk',
    division: 'Cement',
  },
  {
    value: 'MOH-Bulk',
    label: 'MOH-Bulk',
    division: null,
  },
  {
    value: 'OPC-Bulk',
    label: 'OPC-Bulk',
    division: 'Cement',
  },
  {
    value: 'PPC-Bulk',
    label: 'PPC-Bulk',
    division: 'Cement',
  },
  {
    value: 'SRC-Bulk',
    label: 'SRC-Bulk',
    division: 'Cement',
  },
  {
    value: 'WC-Bulk',
    label: 'WC-Bulk',
    division: 'White Cement',
  },
  {
    value: 'WC-Import - Bulk',
    label: 'WC-Import - Bulk',
    division: null,
  },
  {
    value: 'White Cem-I Bags',
    label: 'White Cem-I Bags',
    division: 'White Cement',
  },
  {
    value: 'White Cem-II Bags',
    label: 'White Cem-II Bags',
    division: 'White Cement',
  },
  {
    value: 'FHD-Bags',
    label: 'FHD-Bags',
    division: null,
  },
  {
    value: 'FNG-Bags',
    label: 'FNG-Bags',
    division: 'Cement',
  },
  {
    value: 'MOH-Bags',
    label: 'MOH-Bags',
    division: null,
  },
  {
    value: 'OPC-Bags',
    label: 'OPC-Bags',
    division: 'Cement',
  },
  {
    value: 'PPC-Bags',
    label: 'PPC-Bags',
    division: 'Cement',
  },
  {
    value: 'SRC-Bags',
    label: 'SRC-Bags',
    division: 'Cement',
  },
  {
    value: 'WC-Bags',
    label: 'WC-Bags',
    division: 'White Cement',
  },
  {
    value: 'WC-Import - Bags',
    label: 'WC-Import - Bags',
    division: null,
  },
];

export const TRUCK_TYPES = [
  { value: 'FLAT_BED', label: 'Flat Bed' },
  { value: 'BULKER', label: 'Bulker' },
];

export const TRUCK_TYPES_MAPPING = {
  BULKER: [
    {
      value: 'BULKER',
      label: 'Bulker',
    },
  ],
  FLAT_BED: [
    {
      value: 'FLAT_BED',
      label: 'Flat Bed',
    },
  ],
};

export const DELIVERY_MODES = [
  { value: 'DAT', label: 'DAT' },
  { value: 'EX_WORK', label: 'Ex Work' },
];

export const ORDER_STATUSES = [
  'PROPOSED',
  'ORDERED',
  'CONFIRMED',
  'DISPATCHED',
  'LOADING',
  'IN_ROUTE',
  'UNLOADING',
  'UNASSIGNED',
  'EXCEPTION',
  'DELIVERED',
  'CANCELLED',
];

export const ORDER_TYPES = ['DAT', 'EXWORK', 'FORECAST'];

export const batchRequestTypes = [
  { value: 'CREATE_BATCH_ORDERS', label: 'Create Batch Direct Orders' },
  { value: 'CREATE_BATCH_FORECAST_ORDERS', label: 'Create Batch Forecast Orders' },
  { value: 'ASSIGN_BATCH_FORECAST_ORDERS', label: 'Assign Batch Forecast Orders' },
];

export const SPLIT_BY = [
  { value: '25', label: '25 MT' },
  { value: '30', label: '30 MT' },
  { value: 'other', label: I18n.str('other', 'Other') },
];

export const SALES_CATEGORIES_MAPPING = {
  BULKER: [
    { value: 'BLC-Bulk', label: 'BLC-Bulk' },
    { value: 'Type-II Bulk', label: 'Type-II Bulk' },
    { value: 'Type-III Bulk', label: 'Type-III Bulk' },
    {
      value: 'Flyash-Bulk',
      label: 'Flyash-Bulk',
    },
    {
      value: 'Microsilica-Bulk',
      label: 'Microsilica-Bulk',
    },
    {
      value: 'GGBFS-Bulk',
      label: 'GGBFS-Bulk',
    },
    { value: 'Cement Ash', label: 'Cement Ash' },
    { value: 'White Cem-I Bulk', label: 'White Cem-I Bulk' },
    { value: 'White Cem-II Bulk', label: 'White Cem-II Bulk' },
    { value: 'Clinker', label: 'Clinker' },
    { value: 'FNG-Bulk', label: 'FNG-Bulk' },
    { value: 'MOH-Bulk', label: 'MOH-Bulk' },
    { value: 'OPC-Bulk', label: 'OPC-Bulk' },
    { value: 'OPC-Bulk (Premium)', label: 'OPC-Bulk (Premium)' },
    { value: 'PPC-Bulk', label: 'PPC-Bulk' },
    { value: 'SRC-Bulk', label: 'SRC-Bulk' },
    { value: 'WC-Bulk', label: 'WC-Bulk' },
    { value: 'WC-Import - Bulk', label: 'WC-Import - Bulk' },
    { value: 'PRECASTO', label: 'Precasto' },
    { value: 'BOUNIAN', label: 'Bounian' },
    { value: 'Green Concrete', label: 'Green Concrete' },
  ],
  FLAT_BED: [
    { value: 'White Cem-I Bags', label: 'White Cem-I Bags' },
    { value: 'White Cem-II Bags', label: 'White Cem-II Bags' },
    { value: 'FHD-Bags', label: 'FHD-Bags' },
    { value: 'FNG-Bags', label: 'FNG-Bags' },
    { value: 'MOH-Bags', label: 'MOH-Bags' },
    { value: 'OPC-Bags', label: 'OPC-Bags' },
    { value: 'PPC-Bags', label: 'PPC-Bags' },
    { value: 'SRC-Bags', label: 'SRC-Bags' },
    {
      value: 'Flyash-Bags',
      label: 'Flyash-Bags',
    },
    {
      value: 'Microsilica-Bags',
      label: 'Microsilica-Bags',
    },
    {
      value: 'GGBFS-Bags',
      label: 'GGBFS-Bags',
    },
    { value: 'WC-Bags', label: 'WC-Bags' },
    { value: 'MCT-Bags', label: 'MCT-Bags' },

    { value: 'WC-Import - Bags', label: 'WC-Import - Bags' },
    { value: 'JORDAN', label: 'Jordan' },
  ],
};

export const getTableName = (count) => I18n.str('waybills', 'Waybills ({count})', {
  count: count || 0,
});

export const getColumnName = () => I18n.str('waybill', 'Waybill');

export const getButtonName = () => I18n.str('exportWaybills', 'Export Waybills');

export const getDialogTitle = () => I18n.str('ExportWaybillsReport', 'Export waybills report');

export const getFieldName = () => I18n.str('waybills', 'Waybills');

export const getSearchFieldName = () => I18n.str('waybillNumber', 'Waybill Number');

export const getPlaceHolderName = () => I18n.str('enterWaybillNumber', 'Enter Waybill Number');

export const getRefTableName = (reference) => I18n.str('referenceWaybills', 'Reference {reference} waybills', {
  reference,
});

export const getCustTableName = (phone) => I18n.str('customerWaybills', 'Customer Waybills {phone}', { phone });
